import React, { Component } from 'react';
import PropTypes from 'prop-types';
import translations from '@shopify/polaris/locales/es.json';
import { Page, AppProvider } from '@shopify/polaris';
import { tModel } from '@utils';

const propTypes = {
  seller: PropTypes.object.isRequired,
};


const SellerShow = ({ seller }) => (
  <AppProvider i18n={translations}>
    <Page
      title={ tModel("seller") }
      primaryAction={{ content: 'Create Seller' }}
    >
      <p>
        Content of the Seller.
      </p>
      <p>
        Vendor: {seller.vendor}
      </p>
      <p>
         Legal ID: { seller.legal_id }
      </p>
      <p>
        Address: { seller.address }
      </p>
      <p>
        phone_number: { seller.phone_number}
     </p>

    <p>
      Bank Account number: {seller.bank_account_number}
    </p>

    <p>
      Location: {seller.default_location_id}
    </p>

    </Page>
  </AppProvider>
)


SellerShow.propTypes = propTypes;


export default SellerShow;
